const qrSecKey = {
    id: `qrSecKey-${Math.random()}`,
    title: 'QR Sec Key',
    type: 'item',
    url: `/machines/security-key`,
    // icon: icons.IconReport,
    breadcrumbs: false,
    // children: transChild,
    role: process.env.REACT_APP_RL_MCHQRKEY
};

export default qrSecKey;